import { DateTime } from "luxon"

export class ReasonDateRangeFilter {
    constructor(
        public id: string,
        public startDate: Date,
        public endDate: Date
    ) { }

    appliesToDate(date: Date, timeZone: string): boolean {
        const startOfStartDate = DateTime.fromJSDate(this.startDate, { zone: timeZone }).startOf('day')
        const endOfEndDate = DateTime.fromJSDate(this.endDate, { zone: timeZone }).endOf('day')
        const dateTime = DateTime.fromJSDate(date, { zone: timeZone })
        if (dateTime < startOfStartDate) {
            return false
        }
        if (dateTime > endOfEndDate) {
            return false
        }
        return true
    }
}
